import { render } from "./CompleteProjectsComponent.vue?vue&type=template&id=b331bf48&scoped=true&ts=true"
import script from "./CompleteProjectsComponent.vue?vue&type=script&lang=ts"
export * from "./CompleteProjectsComponent.vue?vue&type=script&lang=ts"

import "./CompleteProjectsComponent.vue?vue&type=style&index=0&id=b331bf48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b331bf48"]])

export default __exports__